import { render, staticRenderFns } from "./DocumentLayer_USER.vue?vue&type=template&id=5edeec02&scoped=true&"
import script from "./DocumentLayer_USER.vue?vue&type=script&lang=js&"
export * from "./DocumentLayer_USER.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLayer_USER.vue?vue&type=style&index=0&id=5edeec02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edeec02",
  null
  
)

export default component.exports